export default __webpack_public_path__ + "static/media/MiniaturaLikeability.8dd581a2.jpg";